<template>
    <div class="school_profile">
        <secondary-banner :title="schoolInfo.schoolName"></secondary-banner>
        <div class="secondary_page_bg">
            <div class="inner">
                <el-breadcrumb separator="/" class="tfboy">
                    <el-breadcrumb-item :to="{ path: '/' }"> <i class="el-icon-location-information"></i> 首页</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ schoolInfo.schoolName }}</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="content">
                    <div class="synop" >
                        <div class="left">
                          <div v-if="schoolInfo.fileUrl!=''&&schoolInfo.fileUrl!=null">
                            <d-player  v-if="schoolInfo.fileUrl.slice(schoolInfo.fileUrl.lastIndexOf('.') + 1)=='mp4'"  ref="vadio" :height="306" :width="509" :vadio-url="schoolInfo.fileUrl"/>
                          </div>
                            <el-image
                              v-else
                              style="width: 509px; height: 306px"
                              :src="schoolInfo.cover"
                              fit="scale-down"></el-image>
                        </div>
                        <div class="right">
                            <el-scrollbar style="height:  306px;"  tag="section">
                                <div class="header">学校介绍</div>
                                <p class="school_synop">{{ schoolInfo.schoolIntroduction }}</p>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="news">
                        <div class="news_title">相关资讯</div>
                        <div class="news_item" v-for="item in newsList" :key="item.id" @click="handlePath(item)">
                            <el-image
                            style="width: 213px; height: 142px;min-width: 213px;"
                            :src="item.noticePic"
                            fit="cover"></el-image>
                            <div class="news_item_content">
                                <div class="news_header">
                                    <div class="newsitem_title txt-line2">{{ item.noticeTitle }}</div>
                                    <div class="news_time">{{ item.createTime }}</div>
                                </div>
                                <p class="news_content" v-html="item.noticeContent.replace(/src/g, ' ')"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SecondaryBanner from "@/components/SecondaryBanner";
import DPlayer from "@/components/DPlayer"
import { getcobreeding, getpartner } from "@/api/home";
import {nocget} from "@/api/notice"
export default {
    name:'SchoolProfile',
    components: { SecondaryBanner,DPlayer},
    data(){
        return {
            schoolInfo:{},
            vadioUrl:'',
            newsList:[]
        }
    },
    created(){
        if(this.$route.query.id){
            this.getcobreeding(this.$route.query.id)

        }else{
            this.$router.push({path:'/'})
        }
    },
    methods:{
        getcobreeding(id){
            getcobreeding(id).then(res=>{
                this.schoolInfo = res.data
              this.nocget({
                    schoolId:this.schoolInfo.schoolId,
                    status:'0'
                })
                getpartner(this.schoolInfo.schoolId).then(res=>{
                    this.schoolInfo.schoolName = res.data.schoolName
                })
            })
        },
        nocget(params){
            nocget(params).then(res=>{
                console.log(res)
                this.newsList = res.rows
            })
        },
        handlePath(item){
            let title = item.noticeType;
            let id = item.noticeId;

            let rourl = this.$router.resolve({
                name: "NoticeDetails",
                params: { name: "natice-detail", title, id },
            });
            window.open(rourl.href);
        }
    }
}
</script>

<style lang="scss" scoped>
.school_profile{
    .secondary_page_bg{
        padding-bottom: 45px;
        overflow: hidden;
    }
    .tfboy{
        margin-top: 39px;
        ::v-deep{
            .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
                color: #1d4434;
            }
            .el-breadcrumb__item:last-child .el-breadcrumb__inner{
                color: #1d4434;
            }
        }
    }
    .txt-line2{
        height: 42px;
        overflow: hidden;
        line-height: 1.2;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .content{
        background-color: #fff;
        padding: 20px;
        margin-top: 32px;
        .synop{
            display: flex;
            margin: 20px 10px;
            margin-bottom: 90px;
            .left{
                width: 509px;
                height: 306px;
            }
            .right{
                flex: 1;
                padding-left: 43px;
                ::v-deep .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
                .header{
                    font-size: 26px;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 28px;
                }
                .school_synop{
                    line-height: 1.7;
                }
            }
        }
        .news{
            .news_title{
                font-size: 26px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 49px;
                text-align: center;
            }
            .news_item{
                display: flex;
                border: 1px solid #EEEEEE;
                border-radius: 10px;
                margin-bottom: 40px;
                padding: 30px;
                transition: all .3s;
                cursor: pointer;
                .news_item_content{
                    flex: 1;
                    padding-left: 38px;
                    .news_header{
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                    }
                    .newsitem_title{
                        font-size: 18px;
                        font-weight: bold;
                        margin-bottom: 15px;
                        width: calc(100% - 150px);
                    }
                    .news_time{
                        color: #999999;
                        font-size: 14px;
                        width: 139px;
                    }
                    .news_content{
                        height: 81px;
                        overflow: hidden;
                        line-height: 1.8;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                    }
                }
                &:hover{
                  box-shadow: 0px 0px 8px 0px rgba(155, 155, 155, 0.21);
                }
            }
        }
    }
}

</style>
